import { createCRUDHook } from './createCRUDHook';
import { DraftPartImagesDto } from 'utils/models';
import { TBL_DRAFT_PART_MULTIPLIER } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<DraftPartImagesDto>(
  {
    entityName: 'DraftPartImages',
    endpoint: TBL_DRAFT_PART_MULTIPLIER,
  }
);

export const DraftPartImagesContext = Context;
export const useDraftPartImagesManager = useManager;
export const useDraftPartImages = useConsumer;
